import React, { useState, useContext, useEffect } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import { getUserCards } from '../GridViewMain/UserCardQuery';
import ForgotPassword from './Recovery/ForgotPassword'; // Import ForgotPassword component
import ResetPassword from './Recovery/ResetPassword'; // Import ResetPassword component
import { AuthContext } from './AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
const SECRET_KEY = "whynotcoconut";

export const UserContext = React.createContext({
  isLoggedIn: localStorage.getItem('isLoggedIn'),
  userId: localStorage.getItem('userId'),
  setUserData: () => {},
});
export function LoginForm() {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.Login[key][currentLang];
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [message, setMessage] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailForVerify,setEmailForVerify] = useState('')
  const [requiresVerification, setRequiresVerification] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [invalidOtp,setInvalidOtp ]= useState(false)
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false); // ✅ Store Remember Me state

  const loginMutation = useMutation((formData) => {
  //  const csrfToken = Cookies.get('_csrf'); // Extract CSRF token
    return fetch(`${process.env.REACT_APP_API_BASE}/api/login2-test`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
        //'x-csrf-token': csrfToken, // Add CSRF token to headers
      },
      credentials: 'include',
    }).then((response) => response.json());
  });

  // Force re-render when `invalidOtp` changes
useEffect(() => {
  if (invalidOtp) {
    setTimeout(() => {
      setInvalidOtp(false);
    }, 500); // Reset after 500ms
  }
}, [invalidOtp]);

useEffect(() => {
  // ✅ Load saved credentials from cookies
  const savedEmail = Cookies.get('rememberedEmail');
  const encryptedPassword = Cookies.get('rememberedPassword');

  if (savedEmail && encryptedPassword) {
    setEmail(savedEmail);

    try {
      // ✅ Decrypt password before setting it
      const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
      const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);

      if (decryptedPassword) {
        setPassword(decryptedPassword);
        setRememberMe(true);
      }
    } catch (error) {
      console.error("❌ Error decrypting password:", error);
    }
  }
}, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setEmailError('');
    setPasswordError('');

    if (email.trim() === '') {
      setEmailError(t('enterEmailError'));
      return;
    }
    if (password.trim() === '') {
      setPasswordError(t('enterPasswordError'));
      return;
    }

    loginMutation.mutate({ email, password }, {
      onSuccess: (data) => {
        if (data.success) {
          // Pass the JWT fallback token returned by the API
       login(
  data.userId,
  data.userName,
  data.csrfToken,
  data.ProfilePicture,
  data.token,
  data.preferredCatalog || 'Hockey',
  data.preferredLanguage || null
);
    
          if (rememberMe) {
            // ✅ Encrypt password before storing in cookies
            const encryptedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
            Cookies.set('rememberedEmail', email, { expires: 30 });
            Cookies.set('rememberedPassword', encryptedPassword, { expires: 30 });
          } else {
            // ✅ Remove credentials if "Remember Me" is unchecked
            Cookies.remove('rememberedEmail');
            Cookies.remove('rememberedPassword');
          }
          // Retrieve intended path from local storage
          const intendedPath = localStorage.getItem('intendedPath') || '/home';
          localStorage.removeItem('intendedPath') // Clear it once used
    
          try {
            navigate(intendedPath, { replace: true });
          } catch (error) {
            setMessage(t('retrieveCardsError'));
          }
        }else if (data.requiresVerification) {
          setRequiresVerification(true); // Show OTP input
          setMessage(data.message);
          console.log('data.Email',data.Email)
          setEmailForVerify(data.Email)
        }
         else {
          setMessage(t('invalidCredentials'));
        }
      },
      onError: (error) => {
        setMessage(t('loginFailed'));
        console.error(error);
      }
    });
  }

   // Handle OTP Verification
   const handleVerifyOTP = async () => {
    const otpCode = otp.join('');
    console.log('emailForVerify',emailForVerify)
    console.log('email',email)
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE}/validateEmail/verify-otp`, {
        email:email,
        otp: otpCode,
      });

      if (response.data.success) {
        toast.success(t('otpVerifiedSuccess'), {position: "top-center"});
        setInvalidOtp(false)
        login(
  response.data.userId,
  response.data.userName,
  response.data.csrfToken || null,
  response.data.ProfilePicture || null,
  response.data.token || null,
  response.data.preferredCatalog || 'Hockey',
  response.data.preferredLanguage || null
);
        navigate('/home');
      } else {
        toast.error(t('invalidOTP'), { position: "top-center"});
       // setMessage(t('invalidOTP'));
       console.log("Before setting invalidOtp:", invalidOtp);
      setInvalidOtp(true); // ✅ This now triggers useEffect to reset after 500ms
      console.log("After setting invalidOtp:", invalidOtp);
     }
    } catch (error) {
      toast.error(t('otpVerificationFailed'), { position: "top-center" });
 
      console.error('OTP Verification Error:', error);
    }
  };
 // Handle OTP input change
 const handleOtpChange = (value, index) => {
  if (/^\d$/.test(value) || value === '') {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  }
};
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <div className='globalLogin'>

      {showForgotPassword ? (
        <ForgotPassword
          setShowResetPasswordForm={setShowResetPasswordForm}
          setShowForgotPassword={setShowForgotPassword}
          setEmail={setEmail}
          setMessage={setMessage}
          t={t}
        />
      ) : showResetPasswordForm ? (
        <ResetPassword email={email} setMessage={setMessage}  t={t}/>
      ) : requiresVerification ? (// OTP Verification UI
        <div style={{ textAlign: 'center' }}>
        <h2>{t('enterOtpTitle')}</h2>
        
        {/* Explanatory Text */}
        <p style={{ marginBottom: '10px', color: '#555' }}>
          {t('otpInstructions')}
        </p>
        
        <div className={`otp-container ${invalidOtp ? "shake" : ""}`} style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '10px' }}>
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleOtpChange(e.target.value, index)}
              style={{
                width: '3rem',
                height: '2rem',
                textAlign: 'center',
                fontSize: '1.5rem',
                borderRadius: '4px',
                border: '1px solid #ccc',
              }}
            />
          ))}
        </div>
      
        {/* Verify OTP Button */}
        <button onClick={handleVerifyOTP} className="btn-base"
            style={{
              width: '100%',
              maxWidth: '300px',
              padding: '10px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '20px',
              marginLeft:'auto',
              marginRight:'auto',
              fontSize: '1rem'
            }}>
          {t('verifyOtpButton')}
        </button>
      </div>
      
      ) : 
      (

        
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', marginTop: '15px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', maxWidth: '300px' }}>
              <label style={{ marginBottom: '5px' }}>{t('usernameOrEmail')}</label>
              <input
                type="text"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%' }}
                className='login-input'
              />
              {emailError && <p className="error" style={{ color: 'red', fontSize: '0.9rem', marginTop: '5px' }}>{emailError}</p>}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', maxWidth: '300px' }}>
              <label style={{ marginBottom: '5px' }}>{t('password')}</label>
              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ flexGrow: 1 }}
                  className='login-input'
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  style={{
                    background: 'white',
                    color: 'black',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.2rem',
                    marginLeft: '-50px',
                    zIndex: 1
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {passwordError && <p className="error" style={{ color: 'red', fontSize: '0.9rem', marginTop: '5px' }}>{passwordError}</p>}
              <div style={{ display: 'flex', alignItems: 'center',width:'100%', justifyContent:'right'}}>

  <label htmlFor="rememberMe" style={{ marginLeft: '5px', fontSize: '0.9rem',marginRight:'10px' }}>
    {t('rememberMe')}
  </label>
  <input
    style={{maxWidth:'fit-content'}}
    type="checkbox"
    id="rememberMe"
    checked={rememberMe}
    onChange={() => setRememberMe(!rememberMe)}
  />
</div>
        
            </div>

            <button
              type="submit"
              className="btn-base"
              style={{
                width: '100%',
                maxWidth: '300px',
                padding: '10px',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px',
                fontSize: '1rem'
              }}
            >
              {t('submit')}
            </button>

            {message && (
          <div style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>
            {message}
          </div>
        )}
        
             <button
              onClick={() => setShowForgotPassword(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#F5F5F5',
                cursor: 'pointer',
                fontSize: '1rem',
                marginTop: '10px',
                textDecoration: 'underline'
              }}
            >
              {t('forgotPassword')}
            </button>
          </div>
        </form>
     
      )}
       
    </div>
  );
}

export default LoginForm;